import { useRouter } from 'next/router'
import { Fragment, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { hideModal } from '@/functions/modal/modalControls'
import { ChevronRight } from 'react-feather'

/**
 * Custom navigation on some pages
 * */
const Navigation = ({ levels, dialog }) => {
    let router = useRouter()
    let dispatch = useDispatch()

    const handleMenuClick = useCallback(() => {
        const nextLink = '/' + router.query.branch
        router.push(nextLink).then(() => {
            if (dialog) {
                hideModal(router, dispatch)
            }
        })
    }, [dialog, dispatch, router.query.branch])

    const handleItemClick = useCallback(() => {
        if (dialog) {
            hideModal(router, dispatch)
        }
    }, [dialog, dispatch, router])

    return (
        <div className={`${dialog ? 'flex' : 'flex lg:container lg:mx-auto mt-4 px-2 xs:px-5'}`}>
            <div
                className={
                    'flex items-center underline hover:cursor-pointer mr-1 font-libre_franklin text-xs tracking-0-03em lg:text-sm'
                }
                onClick={handleMenuClick}
            >
                Menu
            </div>
            {levels &&
                levels.map((item, index) => {
                    if (item !== undefined && item.name !== null) {
                        return (
                            <Fragment key={index}>
                                <div
                                    className={
                                        'font-libre_franklin text-xs tracking-0-03em items-center justify-between flex lg:text-sm'
                                    }
                                >
                                    <ChevronRight size={10} />
                                    <div
                                        key={index}
                                        className={`ml-1 mr-1 font-libre_franklin text-xs tracking-0-03em lg:text-sm ${
                                            item.link && 'underline hover:cursor-pointer'
                                        }`}
                                        onClick={item.link && handleItemClick}
                                    >
                                        {item.name}
                                    </div>
                                </div>
                            </Fragment>
                        )
                    }
                })}
        </div>
    )
}
export default Navigation
